<template>
    <div class="layout-main">
        <TheHeader />

        <router-view class="main" />

        <TheFooter />
    </div>
</template>

<script>
    import TheHeader from '../components/TheHeader'
    import TheFooter from '../components/TheFooter'

    export default {
        name: 'PageMain',
        components: {
            TheHeader,
            TheFooter
        }
    }
</script>

<style lang="scss">
    @import '@/assets/styles/variables';

    .layout-main {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: $color-bg-light;
    }
    .main {
        flex: 1;
        padding: 4rem 0;

        @media screen and ( max-width: map-get($breakpoints, small) - 1 ){
            padding: 2rem 0;
        }
    }
</style>